import "bootstrap/dist/css/bootstrap.min.css";
import Navigation from "./components/Navbar";
import Footer from "./components/Footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import {
  Home,
  Designs,
  Customer,
  Success,
  ErrorPage,
  Cart,
  Checkout,
  SizeGuide,
  Gallery,
  ReturnPolicy,
  PrivacyPolicy,
  TermsOfUse,
  Return,
  OrderLookup,
  ReturnConfirmation,
  Support,
  DataRequest,
  UserVerificationResult,
} from "./pages";
import FallBack from "./components/FallBack";
import DataProvider from "./DataContext";
import { Wrapper } from "./styles";
import Loader from "./components/Loader";
import { AuthenticationGuard } from "./components/AuthenticationGuard";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "react-error-boundary";
import AuthGate from "./components/AuthGate";

function App() {
  return (
    <DataProvider>
      <AuthGate>
        <Wrapper className="main">
          <Loader>
            <BrowserRouter>
              <div className="content">
                <Navigation />
                <ErrorBoundary FallbackComponent={FallBack}>
                  <ScrollToTop />
                  <Routes>
                    <Route index element={<Home />} />
                    <Route path="designs" element={<Designs />} />
                    <Route path="size-guide" element={<SizeGuide />} />
                    <Route path="gallery" element={<Gallery />} />
                    <Route path="return" element={<Return />} />
                    <Route path="order-lookup" element={<OrderLookup />} />
                    <Route path="support" element={<Support />} />
                    <Route path="user-verification-result" element={<UserVerificationResult />} />
                    <Route path="return/confirmation" element={<ReturnConfirmation />} />
                    <Route path="bag" element={<Cart />} />
                    <Route path="checkout" element={<Checkout />} />
                    <Route path="success" element={<Success />} />
                    <Route path="error-page" element={<ErrorPage />} />
                    <Route path="return-policy" element={<ReturnPolicy />} />
                    <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="terms-of-use" element={<TermsOfUse />} />
                    <Route path="data-request" element={<DataRequest />} />
                    <Route path="account" element={<AuthenticationGuard component={Customer} returnTo="/account" />} />
                  </Routes>
                </ErrorBoundary>
              </div>
              <Footer />
            </BrowserRouter>
          </Loader>
          <Toaster
            toastOptions={{
              success: {
                iconTheme: {
                  primary: "#7299a6",
                },
              },
              error: {
                iconTheme: {
                  primary: "#da471f",
                },
              },
            }}
          />
        </Wrapper>
      </AuthGate>
    </DataProvider>
  );
}

export default App;
